<template lang="pug">
article-item-page-template.page-education(
  :title="pageTitle",
  :loading="loading"
)
  template(#main)
    grid-item(row-end="2")
      v-tabs.section-tabs.mx-n.px-1(
        v-model="itemIndex",
        color="white",
        fixed-tabs,
        center-active
      )
        v-tab.font-weight-bold(
          v-for="{ id, title } in items",
          :key="id",
          active-class="primary rounded-t"
        ) {{ title }}
        v-tab-item.pt-4(v-for="(content, i) in items", :key="i")
          template(v-if="!loadingItem[content.id]")
            .pa-3
              v-img.rounded.bordered.mb-2(
                :src="files + '/' + content.mainImg",
                max-height="400px",
                contain
              )
              .ck-content(v-html="content.text")
              images.mt-3(
                v-if="content.imgs && content.imgs.length > 0",
                :items="content.imgs"
              )
              videos.mt-3(
                v-if="content.videos && content.videos.length > 0",
                :items="content.videos"
              )
          template(v-else)
            v-skeleton-loader.mb-4(type="paragraph")
            v-skeleton-loader.mb-4(type="header")
            v-skeleton-loader.mb-4(type="chip")
              v-skeleton-loader.mb-4(type="paragraph")
              v-skeleton-loader.mb-4(type="paragraph")
  template(#side)
    communications-widget
</template>

<script>
import ArticleItemPageTemplate from "@/components/templates/ArticleItemPage";
import CommunicationsWidget from "@/components/widgets/Communications";
import Images from "@/components/sections/Images";
import Videos from "@/components/sections/Videos";

const _config = {
  mod: "education",
  title: "Ensino",
};

export default {
  data: () => ({
    loading: false,
    loadingItem: false,
    itemIndex: null,
  }),
  computed: {
    pageTitle() {
      return _config.title;
    },
    items() {
      return this.$rest(_config.mod).list;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getItem(itemId) {
      this.loadingItem = true;

      this.$rest(_config.mod)
        .get({ id: itemId })
        .then(() => (this.loadingItem = false))
        .catch(() => {
          this.$router.replace("/error404");
        });
    },
  },
  created() {
    this.loading = true;

    this.$rest(_config.mod)
      .get()
      .then(() => {
        this.loading = false;
        this.getItem(this.items[0].id);
      })
      .catch(() => {
        this.$router.replace("/error404");
      });
  },
  watch: {
    itemIndex(v) {
      this.getItem(this.items[v].id);
    },
  },
  components: {
    ArticleItemPageTemplate,
    CommunicationsWidget,
    Images,
    Videos,
  },
};
</script>

<style>
.page-education .v-slide-group__prev--disabled {
  display: none !important;
}
</style>
